import { CompanyPaths } from "Company/Routes/Routing";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { MarketPaths } from "Market/Routes/Routing";
import { ClaimsPaths } from "Order/Modules/Claim/Routes/Routing";
import { InvoicePaths } from "Order/Modules/Invoice/Routes/Routing";
import { OrderPaths } from "Order/Routes/Routing";
import { PartnerStatisticsPaths } from "Partner/Modules/Statistics/Routes/Routing";
import { PartnerPaths } from "Partner/Routes/Routing";
import { PaymentPaths } from "Payment/Routes/Routing";
import { SettingsPaths } from "Settings/Routes/Routing";
import {
	type MenuItemsType,
	MenuItemTypes,
} from "Shared/Components/Layout/Full/Sidebar/Types/MenuItem";
import {
	AdminPanelSettings,
	AttachMoney,
	BarChart,
	Brush,
	Business,
	FireExtinguisher,
	Group,
	ListAlt,
	ManageAccounts,
	Person,
	RequestQuote,
	Store,
	Tune,
} from "@mui/icons-material";
import { CalendarIcon } from "@mui/x-date-pickers";

/**
 * Menu items for the sidebar.
 *
 * For Orders and Partners we've removed the following:
 * href: `${OrderPaths.Index.path}?pageIndex=${DEFAULT_PAGE_INDEX}&pageLimit=${DEFAULT_PAGE_LIMIT}`,
 * href: `${PartnerPaths.Index.path}?pageIndex=${DEFAULT_PAGE_INDEX}&pageLimit=${DEFAULT_PAGE_LIMIT}`,
 *
 * We might need to get it back.
 */
export const MenuItems: MenuItemsType[] = [
	{
		navlabel: true,
		subheader: "Orders",
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.Orders,
		icon: Brush,
		href: OrderPaths.Index.path,
		chipColor: "primary",
		permission: UserPermissions.OrderModule.view,
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.Invoices,
		icon: RequestQuote,
		href: InvoicePaths.List.path,
		chipColor: "primary",
		permission: UserPermissions.InvoiceModule.view,
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.Claims,
		icon: FireExtinguisher,
		href: ClaimsPaths.Index.path,
		chipColor: "primary",
		permission: UserPermissions.OrderClaimModule.view,
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.Payments,
		icon: AttachMoney,
		href: PaymentPaths.Index.path,
		chipColor: "primary",
		permission: UserPermissions.BankModule.view,
	},
	{
		navlabel: true,
		subheader: "Partners",
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.Partners,
		icon: Person,
		href: PartnerPaths.Index.path,
		chipColor: "primary",
		permission: [
			UserPermissions.PartnerModule.read,
			UserPermissions.PartnerModule.create,
		],
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.Calendar,
		icon: CalendarIcon,
		href: PartnerPaths.Calendar.path,
		chipColor: "primary",
		permission: [
			UserPermissions.PartnerModule.read,
			UserPermissions.PartnerModule.create,
		],
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.PartnershipRecords,
		icon: ListAlt,
		href: PartnerPaths.PartnershipRecords.path,
		chipColor: "primary",
		permission: [
			UserPermissions.PartnerModule.read,
			UserPermissions.PartnerModule.create,
		],
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.PartnersStatistics,
		icon: BarChart,
		href: PartnerStatisticsPaths.Index.route,
		chipColor: "primary",
		permission: UserPermissions.PartnerStatisticModule.read,
	},
	{
		navlabel: true,
		subheader: "Settings",
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.Users,
		icon: ManageAccounts,
		href: SettingsPaths.UsersIndex.path,
		level: 2,
		permission: [
			UserPermissions.UserModule.view,
			UserPermissions.UserModule.create,
			UserPermissions.UserRolesModule.read,
		],
		children: [
			{
				id: crypto.randomUUID(),
				title: MenuItemTypes.UsersProfile,
				icon: Group,
				href: SettingsPaths.UsersIndex.path,
				chipColor: "primary",
				permission: UserPermissions.UserModule.view,
			},
			{
				id: crypto.randomUUID(),
				title: MenuItemTypes.UsersRoles,
				icon: AdminPanelSettings,
				href: SettingsPaths.UsersRoles.route,
				chipColor: "primary",
				permission: UserPermissions.UserRolesModule.read,
			},
		],
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.Markets,
		icon: Store,
		href: MarketPaths.Index.route,
		permission: UserPermissions.MarketModule.read,
		chipColor: "primary",
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.Company,
		icon: Business,
		href: CompanyPaths.Index.path,
		permission: UserPermissions.CompanyModule.read,
		chipColor: "primary",
	},
	{
		id: crypto.randomUUID(),
		title: MenuItemTypes.VerticalSetup,
		icon: Tune,
		href: SettingsPaths.VerticalSetupMarketSelect.path,
		permission: UserPermissions.OrderSetupModule.read,
		chipColor: "primary",
	},
];
